import React from 'react';
import './GameRules.css';

// Standalone game-rules screen. Content was previously embedded inside the
// desktop GameInfo panel; extracted so it can be reached from the mobile
// hamburger menu without requiring an active game.
export default function GameRules({ onBack }) {
  const piece = (color, type) => (
    <img
      src={`/assets/pieces/${color}-${type}.png`}
      alt={`${color} ${type}`}
      className="rules-piece-icon"
    />
  );

  return (
    <div className="game-rules-page">
      <div className="game-rules-header">
        <button onClick={onBack} className="back-button">← Back</button>
        <h1>Game Rules</h1>
      </div>

      <div className="game-rules-content">
        <p className="rules-intro">
          Ranga combines elements of Xiangqi, Shogi, and Western Chess on a 9×9 board.
          Each piece has its own movement pattern:
        </p>

        <ul className="rules-list">
          <li>
            {piece('white', 'king')}{piece('black', 'king')}
            <strong>King:</strong> Moves 1 square in any direction.
          </li>
          <li>
            {piece('white', 'knight')}{piece('black', 'knight')}
            <strong>Knight:</strong> Moves in an L-shape (2+1 squares).
          </li>
          <li>
            {piece('white', 'pawn')}{piece('black', 'pawn')}
            <strong>Pawn:</strong> Moves forward, captures diagonally.
          </li>
          <li>
            {piece('white', 'advisor')}{piece('black', 'advisor')}
            <strong>Advisor:</strong> Moves 1–2 squares in any direction.
          </li>
          <li>
            {piece('white', 'cannon')}{piece('black', 'cannon')}
            <strong>Cannon:</strong> Moves like a rook; jumps over one piece to capture.
          </li>
          <li>
            {piece('white', 'camel')}{piece('black', 'camel')}
            <strong>Camel:</strong> Moves in a (3,1) pattern.
          </li>
          <li>
            {piece('white', 'donkey')}{piece('black', 'donkey')}
            <strong>Donkey:</strong> Moves 1 square in any direction or 2 diagonally on the same color.
          </li>
          <li>
            {piece('white', 'ram')}{piece('black', 'ram')}
            <strong>Ram:</strong> Moves like a rook; bumps pieces backward (captures if bumped off board).
          </li>
          <li>
            {piece('white', 'spy')}{piece('black', 'spy')}
            <strong>Spy:</strong> Moves 1 square in any direction or any number of squares backward.
          </li>
        </ul>
      </div>
    </div>
  );
}
